import { render, staticRenderFns } from "./CheckboxFormItem.vue?vue&type=template&id=0422f576&"
import script from "./CheckboxFormItem.vue?vue&type=script&lang=js&"
export * from "./CheckboxFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports